/**
 * Product Gallery Enhancement
 * Handles thumbnail clicks, slider sync, and video autoplay
 */
(function($) {
  'use strict';

  function initProductGallery() {
    const $productImages = $('.product-images.slick');
    const $thumbnails = $('.product-thumbnails');
    const $thumbnailItems = $thumbnails.find('.product-thumbnail');

    if (!$productImages.length || !$thumbnails.length) {
      return;
    }

    // Wait for slick to be initialized
    const checkSlick = setInterval(function() {
      if ($productImages.hasClass('slick-initialized')) {
        clearInterval(checkSlick);
        
        // Enable infinite loop
        try {
          // Try to get current setting first
          const currentInfinite = $productImages.slick('getOption', 'infinite');
          if (currentInfinite !== true) {
            // Set infinite to true and refresh the slider (third param = refresh)
            $productImages.slick('slickSetOption', 'infinite', true, true);
          }
          $productImages.slick('refresh');
        } catch (e) {
          // If getOption fails, try to set it directly
          try {
            $productImages.slick('slickSetOption', 'infinite', true, true);
          } catch (e2) {
            // If that also fails, the slider might not support this option change
            console.warn('Could not enable infinite loop on product slider');
          }
        }
        
        setupProductGallery();
      }
    }, 100);

    function setupProductGallery() {
      // Handle thumbnail clicks (enhance existing functionality)
      $thumbnailItems.off('click.productGallery').on('click.productGallery', function(e) {
        const $thumb = $(this);
        const index = $thumb.index();

        // Update thumbnail active state
        $thumbnailItems.removeClass('slick-current');
        $thumb.addClass('slick-current');

        // Navigate slider to clicked thumbnail
        if ($productImages.hasClass('slick-initialized')) {
          $productImages.slick('slickGoTo', index);
        }
      });

      // Sync thumbnails when slider changes (via arrows, swipe, etc.)
      // Use namespace to avoid conflicts
      $productImages.off('afterChange.productGallery').on('afterChange.productGallery', function(event, slick, currentSlide) {
        // Slick's afterChange provides the logical slide index (0 to slideCount-1)
        // which is perfect for matching with thumbnails
        const slideIndex = currentSlide;
        
        // Update thumbnail active state
        $thumbnailItems.removeClass('slick-current');
        $thumbnailItems.eq(slideIndex).addClass('slick-current');

        // Scroll thumbnail into view if needed
        const $activeThumb = $thumbnailItems.eq(slideIndex);
        if ($activeThumb.length) {
          const thumbContainer = $thumbnails[0];
          const thumbRect = $activeThumb[0].getBoundingClientRect();
          const containerRect = thumbContainer.getBoundingClientRect();

          // Check if thumbnail is not fully visible
          if (thumbRect.top < containerRect.top || thumbRect.bottom > containerRect.bottom) {
            $activeThumb[0].scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'nearest'
            });
          }
        }

        // Autoplay video if current slide contains a video
        // Use the actual displayed slide (currentSlide) for video, not the calculated index
        const $currentSlide = slick.$slides.eq(currentSlide);
        const $media = $currentSlide.find('.product-single__media');

        // Pause all videos first
        pauseAllVideos();

        // Autoplay video in current slide
        if ($media.hasClass('product-single__media-external-video')) {
          autoplayExternalVideo($media);
        } else if ($media.hasClass('product-single__media-native-video')) {
          autoplayNativeVideo($media);
        }
      });

      // Handle initial video autoplay if first slide is a video
      const $firstSlide = $productImages.find('.product-image').first();
      const $firstMedia = $firstSlide.find('.product-single__media');
      if ($firstMedia.hasClass('product-single__media-external-video') || 
          $firstMedia.hasClass('product-single__media-native-video')) {
        setTimeout(function() {
          if ($firstMedia.hasClass('product-single__media-external-video')) {
            autoplayExternalVideo($firstMedia);
          } else if ($firstMedia.hasClass('product-single__media-native-video')) {
            autoplayNativeVideo($firstMedia);
          }
        }, 500);
      }
    }
  }

  function pauseAllVideos() {
    // Pause all native videos
    $('.product-single__media-native-video video').each(function() {
      if (this.pause) {
        this.pause();
      }
    });

    // Pause all external videos (YouTube, Vimeo)
    $('.product-single__media-external-video').each(function() {
      const $media = $(this);
      const provider = $media.data('provider');
      const $iframe = $media.find('iframe');

      if ($iframe.length) {
        // Check if YouTube (could be 'youtube' or 'youtube.com')
        if (provider && provider.toLowerCase().indexOf('youtube') !== -1) {
          try {
            $iframe[0].contentWindow.postMessage(
              JSON.stringify({
                event: 'command',
                func: 'pauseVideo',
                args: ''
              }),
              '*'
            );
          } catch (e) {
            console.warn('Could not pause YouTube video:', e);
          }
        } 
        // Check if Vimeo (could be 'vimeo' or 'vimeo.com')
        else if (provider && provider.toLowerCase().indexOf('vimeo') !== -1) {
          try {
            $iframe[0].contentWindow.postMessage(
              JSON.stringify({
                method: 'pause'
              }),
              '*'
            );
          } catch (e) {
            console.warn('Could not pause Vimeo video:', e);
          }
        }
      }
    });
  }

  function autoplayExternalVideo($media) {
    const provider = $media.data('provider');
    const $iframe = $media.find('iframe');

    if (!$iframe.length) {
      return;
    }

    // Wait a bit for iframe to be ready
    setTimeout(function() {
      try {
        // For YouTube (could be 'youtube' or 'youtube.com')
        if (provider && provider.toLowerCase().indexOf('youtube') !== -1) {
          // Try to play using postMessage
          $iframe[0].contentWindow.postMessage(
            JSON.stringify({
              event: 'command',
              func: 'playVideo',
              args: ''
            }),
            '*'
          );
        }
        // For Vimeo (could be 'vimeo' or 'vimeo.com')
        else if (provider && provider.toLowerCase().indexOf('vimeo') !== -1) {
          // Try to play using postMessage
          $iframe[0].contentWindow.postMessage(
            JSON.stringify({
              method: 'play'
            }),
            '*'
          );
        }
      } catch (e) {
        console.warn('Could not autoplay external video:', e);
      }
    }, 300);
  }

  function autoplayNativeVideo($media) {
    const $video = $media.find('video');
    if ($video.length) {
      const video = $video[0];
      
      // Wait a bit for video to be ready
      setTimeout(function() {
        if (video && video.play) {
          // Ensure video is muted for autoplay (browser requirement)
          video.muted = true;
          
          // Try to play
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.catch(function(e) {
              console.warn('Could not autoplay video:', e);
            });
          }
        }
      }, 300);
    }
  }

  // Initialize when DOM is ready
  $(document).ready(function() {
    initProductGallery();
  });

  // Re-initialize on section load (for theme editor and dynamic loading)
  $(document).on('shopify:section:load', function() {
    initProductGallery();
  });

})(window.jQuery || window.$);

